import $ from 'jquery';
export default {
    name: 'categories',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            cat_is_loading: true,
            cat_is_empty: false
        }
    },
    computed: {
        categoriesVisitesMedicales() {
            return this.$store.getters["categoriesVM"];
        }


    },
    mounted() {
        this.$store.dispatch("getCategoriesVisitesMedicales").then(() => {
            console.log("--->>>>> ", this.categoriesVisitesMedicales)
            if (this.categoriesVisitesMedicales.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            this.is_loading = false
        })
        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);
    },
    methods: {

    }
}


